import { cn } from "@/lib/utils";
import { t } from "@/lib/i18n";

const styles = {
  // device statuses
  idle: "bg-slate-100 text-slate-700",
  offline: "bg-slate-100 text-slate-500",
  warming: "bg-amber-100 text-amber-700",
  posting: "bg-emerald-100 text-emerald-700",
  watching_stream: "bg-blue-100 text-blue-700",
  commenting: "bg-violet-100 text-violet-700",
  sleeping: "bg-indigo-100 text-indigo-700",
  alert: "bg-rose-100 text-rose-700",
  // account stages
  active: "bg-emerald-100 text-emerald-700",
  paused: "bg-amber-100 text-amber-700",
  banned: "bg-rose-100 text-rose-700",
  shadowbanned: "bg-rose-100 text-rose-700",
  warmup: "bg-amber-100 text-amber-700",
  // schedule/stream statuses
  planned: "bg-slate-100 text-slate-700",
  running: "bg-emerald-100 text-emerald-700",
  done: "bg-blue-100 text-blue-700",
  failed: "bg-rose-100 text-rose-700",
  // video statuses
  queued: "bg-amber-100 text-amber-700",
  draft: "bg-slate-100 text-slate-600",
  posted: "bg-emerald-100 text-emerald-700",
};

const labels = {
  // devices
  idle: t.devices.status.idle,
  offline: t.devices.status.offline,
  warming: t.devices.status.warming,
  posting: t.devices.status.posting,
  watching_stream: t.devices.status.watching_stream,
  commenting: t.devices.status.commenting,
  sleeping: t.devices.status.sleeping,
  alert: t.devices.status.alert,
  // accounts
  warmup: t.accounts.stage.warmup,
  active: t.accounts.stage.active,
  paused: t.accounts.stage.paused,
  banned: t.accounts.stage.banned,
  shadowbanned: t.accounts.stage.shadowbanned,
  // schedule
  planned: t.schedule.status.planned,
  running: t.schedule.status.running,
  done: t.schedule.status.done,
  failed: t.schedule.status.failed,
  // videos
  queued: "в очереди",
  draft: "черновик",
  posted: "опубликовано",
};

export default function StatusBadge({ status, className }) {
  const cls = styles[status] || "bg-slate-100 text-slate-700";
  const dotAnimate = ["posting", "warming", "watching_stream", "commenting", "running", "active"].includes(status);
  const label = labels[status] || status?.replace(/_/g, " ");
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-medium ring-1 ring-inset ring-black/5",
        cls,
        className
      )}
    >
      <span className={cn("h-1.5 w-1.5 rounded-full bg-current", dotAnimate && "animate-pulse")} />
      {label}
    </span>
  );
}
